export const SURVEY_ORIGIN = {
    BOOKING_PAGE: "bookingPage",
};
export const SURVEY_STATUS = {
    NOT_STARTED: "Not started",
    INCOMPLETE: "Incomplete",
    TO_BE_CONTINUED_BY_RESPONDENT: "To be continued by respondent",
    FOR_ACTION_BY_MANAGER: "For action by manager",
    COMPLETED: "Completed",
    AUTO_CLOSED: "Auto-closed",
    CLOSED: "Closed",
};
export const SURVEY_INVOICE_PROPERTIES = [
    { name: "billToName", displayName: "Bill To: Company Name", type: "boolean" },
    {
        name: "billToBusinessNumber",
        displayName: "Bill To: Company Number (ABN or registration number)",
        type: "boolean",
    },
    {
        name: "billToAddressLine1",
        displayName: "Bill To: Company Address Line 1",
        type: "boolean",
    },
    {
        name: "billToAddressLine2",
        displayName: "Bill To: Company Address Line 2",
        type: "boolean",
    },
    {
        name: "billToEmail",
        displayName: "Bill To: Invoice Recipient Email",
        type: "boolean",
    },
    {
        name: "purchaseOrderNumber",
        displayName: "Purchase Order Number",
        type: "boolean",
    },
];
export var SERVICE_SURVEY_TYPE;
(function (SERVICE_SURVEY_TYPE) {
    SERVICE_SURVEY_TYPE["PRE_SERVICE"] = "PRE_SERVICE";
    SERVICE_SURVEY_TYPE["POST_SERVICE"] = "POST_SERVICE";
})(SERVICE_SURVEY_TYPE || (SERVICE_SURVEY_TYPE = {}));
//# sourceMappingURL=survey.js.map